export const imgIxParams = {
    profile: {
        xs: '?h=32&fit=facearea&facepad=2&crop=faces',
        sm: '?h=48&fit=facearea&facepad=2&crop=faces',
        md: '?h=64&fit=facearea&facepad=2&crop=faces',
        lg: '?h=88&fit=crop&crop=center',
        xl: '?h=96&fit=crop&crop=center',
    }
}